export const FormSections2055 = [
	'overview',
	'subject',
	'neighborhood',
	'improvements',
	'comps',
	'salesapproach',
	'costapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];

export const UiSections2055 = FormSections2055;

export enum RulesBase2055 {
	OVERVIEW = 1000,
	REVISIONS = 1050,
	SUBJECT = 2000,
	NEIGHBORHOOD = 3000,
	IMPROVEMENTS= 4000,
	COMPS = 5000,
	SALESAPPROACH = 6000,
	COSTAPPROACH = 7000,
	INCOMEAPPROACH = 8000,
	RECONCILIATION = 9000,
	PDFREVIEW = 10000,
	PHOTOREVIEW = 11000
}
